import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Trans } from 'react-i18next';
class RegistrationSuccess extends Component {
    constructor(props) {
        super(props);

        this.updateDimensions = this.updateDimensions.bind(this);

        this.state = {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            x3: 0,
            y3: 0
        }
    }

    componentDidMount() {        
        document.title = "Survey - FleetXPress"
        this.updateDimensions()
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions() {
        var ss1 = document.getElementById('survey-success-1')
        var ss2 = document.getElementById('survey-success-2')
        //var ss3 = document.getElementById('survey-success-3')
        this.setState({
            x1: ss1.offsetLeft-22,
            y1: ss1.offsetTop-12,
            x2: ss2.offsetLeft-22,
            y2: ss2.offsetTop-35,
            //x3: ss3.offsetLeft-22,
            //y3: ss3.offsetTop-35
        })
    }

    render() {
        return (
            <div className = "validation-container">
                {
                    /*
                        <svg width="100%" height="100%" style={{position: 'absolute'}}><line x1={this.state.x1} y1={this.state.y1} x2={this.state.x2} y2={this.state.y2} className="registration-step-line"/></svg>
                        <svg width="100%" height="100%" style={{position: 'absolute'}}><line x1={this.state.x2} y1={this.state.y2 + 25} x2={this.state.x3} y2={this.state.y3} className="registration-step-line"/></svg>
                    */
                }
                <div className="registration-navbar">
                    <img src="images/dvms_logo.png" />
                </div>
                <div className="registration-card validation-card">
                    <div className="registration-header">
                        <div className="registration-heading">
                            <Trans>You're all set!</Trans>
                        </div>
                        <div className="registration-subheading">
                            <Trans>You will be notified as soon as you are approved. Continue to access FleetXPress and its features.</Trans>
                        </div>
                    </div>
                    <div className="registration-main" style={{flexWrap: 'wrap', margin: "10vh 0"}}>
                        <div className="registration-success-left">
                            <img src="/images/icons/Wheel_Lastpage.svg" />
                        </div>
                        <div className="registration-success-right">
                            <div className="survey-success-item" style={{margin: "0 0 auto 0"}}>
                                <div className="survey-success-step" id="survey-success-1">
                                    <span>1</span>
                                    <div className="survey-vertical-line"></div>
                                </div>
                                <div className="survey-success-div">
                                    <div className="survey-success-header">
                                        <Trans>Make or modify your bookings in seconds.</Trans>
                                    </div>
                                </div>
                            </div>
                           
                            <div className="survey-success-item" style={{margin: "auto 0"}}>
                                <div className="survey-success-step" id="survey-success-2">
                                    <span>2</span>
                                    <div className="survey-vertical-line"></div>
                                </div>
                                <div className="survey-success-div">
                                    <div className="survey-success-header">
                                        <Trans>Access multiple fleets online.</Trans>
                                    </div>
                                </div>
                            </div>
                            <div className="survey-success-item" style={{margin: "auto 0 0 0"}}>
                                <div className="survey-success-step" id="survey-success-3"><span>3</span></div>
                                <div className="survey-success-div">
                                    <div className="survey-success-header">
                                        <Trans>Select the right vehicles for your needs</Trans>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="registration-single-action">
                        <div className="registration-continue-button" onClick={() => this.props.history.push("/")}>
                            <Trans>Continue</Trans>
                            <i className="fas fa-arrow-right mobile-only" style={{margin: "auto auto auto 10px"}}></i>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings
})

export default connect(mapStateToProps,)(RegistrationSuccess);